// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2tyLN","inner":"Footer_inner__35Dzs","nextIcon":"Footer_nextIcon__1Ejgl","innerLeft":"Footer_innerLeft__1vaFI"};